var _mask, _path, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 44,
    viewBox: "0 0 56 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_749_2878",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9223 2.683C40.9223 1.20122 39.7211 0 38.2393 0H17.7592C16.2774 0 15.0762 1.20122 15.0762 2.683C15.0762 4.16478 13.875 5.366 12.3932 5.366H4C1.79086 5.366 0 7.15686 0 9.366V40.0001C0 42.2093 1.79086 44.0001 4 44.0001H52C54.2091 44.0001 56 42.2093 56 40.0001V9.366C56 7.15686 54.2091 5.366 52 5.366H43.6053C42.1235 5.366 40.9223 4.16478 40.9223 2.683Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7592 2H38.2393V-2H17.7592V2ZM4 7.366H12.3932V3.366H4V7.366ZM2 40.0001V9.366H-2V40.0001H2ZM52 42.0001H4V46.0001H52V42.0001ZM54 9.366V40.0001H58V9.366H54ZM43.6053 7.366H52V3.366H43.6053V7.366ZM43.6053 3.366C43.2281 3.366 42.9223 3.06021 42.9223 2.683H38.9223C38.9223 5.26935 41.019 7.366 43.6053 7.366V3.366ZM58 9.366C58 6.05229 55.3137 3.366 52 3.366V7.366C53.1046 7.366 54 8.26144 54 9.366H58ZM52 46.0001C55.3137 46.0001 58 43.3139 58 40.0001H54C54 41.1047 53.1046 42.0001 52 42.0001V46.0001ZM-2 40.0001C-2 43.3139 0.686294 46.0001 4 46.0001V42.0001C2.89543 42.0001 2 41.1047 2 40.0001H-2ZM4 3.366C0.686292 3.366 -2 6.05229 -2 9.366H2C2 8.26143 2.89543 7.366 4 7.366V3.366ZM13.0762 2.683C13.0762 3.06021 12.7704 3.366 12.3932 3.366V7.366C14.9795 7.366 17.0762 5.26935 17.0762 2.683H13.0762ZM38.2393 2C38.6165 2 38.9223 2.30579 38.9223 2.683H42.9223C42.9223 0.0966502 40.8257 -2 38.2393 -2V2ZM17.7592 -2C15.1728 -2 13.0762 0.0966521 13.0762 2.683H17.0762C17.0762 2.30579 17.382 2 17.7592 2V-2Z",
    fill: "#D1D1D1",
    mask: "url(#path-1-inside-1_749_2878)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 25,
    r: 9,
    stroke: "#D1D1D1",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 14.0771,
    r: 2,
    fill: "#D1D1D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.da2ba24ff4d3e7ee5602166a79832127.svg";
export { ForwardRef as ReactComponent };